// extracted by mini-css-extract-plugin
export default {"input":"input__T9-WI","label":"label__CiGQx","hidden":"hidden__Uyc3R"};